import React, { type TextareaHTMLAttributes } from "react";

import classNames from "classnames";

import style from "./TextArea.module.css";

export type TextAreaProps = {
  error?: boolean;
  errorMessage?: string;
};

export const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement> & TextAreaProps
>(({ error, errorMessage, ...attrs }, ref) => {
  return (
    <div className={classNames(style.wrapper, attrs.className)}>
      <div className={classNames(style.inputWrapper, (error || errorMessage) && style.error)}>
        <textarea
          {...attrs}
          ref={ref}
          className={classNames(style.textArea, (error || errorMessage) && style.error)}
        />
      </div>
      {errorMessage && <span className={style.errorMessage}>{errorMessage}</span>}
    </div>
  );
});

TextArea.displayName = "TextArea";
